'use client'

import * as TabsPrimitive from '@radix-ui/react-tabs'

import { TabsList } from '~/components/component-library/Tabs/components/TabsList'
import { TabsTrigger } from '~/components/component-library/Tabs/components/TabsTrigger'
import { type TabOption } from '~/components/component-library/Tabs/types'
import { cn } from '~/utils/tailwind-utils'

export { TabsList } from '~/components/component-library/Tabs/components/TabsList'
export { TabsTrigger } from '~/components/component-library/Tabs/components/TabsTrigger'
export { TabsContent } from '~/components/component-library/Tabs/components/TabsContent'
export { type TabOption } from '~/components/component-library/Tabs/types'

type ITabs = TabsPrimitive.TabsProps & {
  options: TabOption[]
}

export const Tabs = ({
  children,
  options = [],
  className,
  ...props
}: ITabs) => (
  <TabsPrimitive.Root {...props} className={cn('space-y-6', className)}>
    <TabsList>
      {options.map(({ value, display, isDisabled }) => (
        <TabsTrigger key={value} value={value} isDisabled={isDisabled}>
          {display}
        </TabsTrigger>
      ))}
    </TabsList>
    {children}
  </TabsPrimitive.Root>
)
